module.exports = __webpack_public_path__ + "img/t3-gray.39e3c550.png";